import { Feature, isAvailable, hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

export const hasTodoCustomFields = () => {
	// This is so we only show it for customers that have access to activity custom fields (did not make a new type for these as both todos and phonecalls are under the Activity feature)
	const hasActivityCustom = isAvailable(Feature.ACTIVITY_CUSTOM);
	// If they event have todos
	const hasTodoList = hasSoftDeployAccess('TODO_LIST');
	// This is so we do not show them for customers that still uses old activities
	const hasRemoveActivities = hasSoftDeployAccess('REMOVE_ACTIVITIES');
	return hasActivityCustom && hasTodoList && hasRemoveActivities;
};
